var _mask, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoResults = function SvgNoResults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 83 83"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "noResults_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 41.5C0 18.58 18.58 0 41.5 0S83 18.58 83 41.5 64.42 83 41.5 83 0 64.42 0 41.5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0054A6",
    d: "M41.5 83v-1C19.133 82 1 63.868 1 41.5h-2C-1 64.972 18.028 84 41.5 84zM83 41.5h-1C82 63.868 63.868 82 41.5 82v2C64.972 84 84 64.972 84 41.5zM41.5 0v1C63.868 1 82 19.133 82 41.5h2C84 18.028 64.972-1 41.5-1zm0 0v-1C18.028-1-1 18.028-1 41.5h2C1 19.133 19.133 1 41.5 1z",
    mask: "url(#noResults_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0054A6",
    d: "M41.5 62q-2.786 0-4.643-1.645Q35 58.65 35 56.152t1.857-4.143q1.857-1.706 4.643-1.706t4.643 1.706Q48 53.653 48 56.152t-1.857 4.203Q44.286 62 41.5 62m-2.9-14.256a2 2 0 0 1-1.996-1.87l-1.467-22.745A2 2 0 0 1 37.133 21h8.556a2 2 0 0 1 1.997 2.109l-1.241 22.744a2 2 0 0 1-1.997 1.891z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 41.001,
    r: 36.75,
    stroke: "#0054A6",
    strokeWidth: 0.5
  })));
};
export default SvgNoResults;